// extracted by mini-css-extract-plugin
export default {"topics__container":"TopicsList_topics__container__yk+g8"};